import { useMemo } from 'react';
import { useAssignableMembers } from '../../../../hooks/useRoles';
import type { ListFilterSummary } from '../../shared/listFilterSummary';
import { useSharedFilterSources } from '../../shared/useSharedFilterSources';
import type { MessageListParams } from '../messageListParams';
import { messageListSummary } from '../messageListSummary';

export function useMessageListSummary(
    listParams: MessageListParams,
    total: number | null
): ListFilterSummary {
    const { tags, status, sort, order } = listParams;
    const { members: people } = useAssignableMembers();
    const shared = useSharedFilterSources(listParams, people);
    return useMemo(
        () => messageListSummary({ shared, tags, status, sort, order, total }),
        [shared, tags, status, sort, order, total]
    );
}
